// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"152":"6dc14bcd","453":"88e0c826","996":"5d346945"}[chunkId] + ".chunk.js";
};